export const getCollaboratorInitials = (collaborator: {
  firstName?: string;
  lastName?: string;
  email?: string;
}) => {
  if (collaborator.firstName && collaborator.lastName) {
    return collaborator.firstName[0] + collaborator.lastName[0];
  }
  return collaborator.email?.slice(0, 1) ?? '';
};
